module.exports = __webpack_public_path__ + "img/page_title_01.ef475d0e.png";